"use client"

import { useEffect, useRef, useState } from "react"

const ScrollAnimation = ({ children, animation = "fade-in-up", delay = 0, className = "" }) => {
  const [isVisible, setIsVisible] = useState(false)
  const elementRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true)
          }, delay)
        }
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      },
    )

    if (elementRef.current) {
      observer.observe(elementRef.current)
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current)
      }
    }
  }, [delay])

  return (
    <div ref={elementRef} className={`${animation} ${isVisible ? "animate" : ""} ${className}`}>
      {children}
    </div>
  )
}

export default ScrollAnimation
